import { useMemo } from "react";

import { CurrencyValue } from "@every.org/common/src/codecs/currency";
import { Currency } from "@every.org/common/src/entity/types";
import { minimumDenominationAmountToCurrencyValue } from "@every.org/common/src/helpers/currency";
import {
  DEFAULT_BOUNDS_FOR_DONATION_VALUE,
  DEFAULT_FRONTEND_BOUNDS_FOR_DONATION_VALUE,
} from "@every.org/common/src/helpers/donationValue";

export function useAmountLimits(
  minDonationValue?: CurrencyValue,
  _currency?: Currency,
  hasAmountQueryParam?: boolean
): [min: CurrencyValue, max: CurrencyValue] {
  const currency = minDonationValue?.currency || _currency || Currency.USD;

  // Use default frontend bounds ($10 minimum) unless amount query param is present
  const boundsToUse = hasAmountQueryParam
    ? DEFAULT_BOUNDS_FOR_DONATION_VALUE
    : DEFAULT_FRONTEND_BOUNDS_FOR_DONATION_VALUE;

  const defaultBounds = boundsToUse[currency];

  const [min, max] = useMemo(
    () =>
      [minDonationValue || defaultBounds.min, defaultBounds.max].map((amt) =>
        typeof amt === "number"
          ? minimumDenominationAmountToCurrencyValue({
              currency,
              amountInMinDenom: amt,
            })
          : amt
      ),
    [defaultBounds.max, defaultBounds.min, minDonationValue, currency]
  );

  return [min, max];
}
